import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { MijnWebcomponentIdentifier } from '@ap/mijn-navigatie';

import { TemplateClickActions, TemplateClickEvent, TemplateSettings } from './mijn-omgeving-template.model';

@Injectable({ providedIn: 'root' })
export class MijnOmgevingTemplateService {
    private templateClickActions: TemplateClickActions;

    private readonly mijnOmgevingElement = 'mijn-omgeving';
    private readonly templateSettings = 'templateSettings';
    private readonly templateClickEvent = 'templateClickEvent';

    public constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    public setTemplateSettings(settings: TemplateSettings): void {
        const webElement = this.document.querySelector(this.mijnOmgevingElement);
        this.setupTemplateClickActions(settings);
        const event: CustomEvent = new CustomEvent(this.templateSettings, {
            detail: {
                ...settings
            }
        });
        webElement?.dispatchEvent(event);
    }

    public sendTemplateClickEvent(webcomponentIdentifier: MijnWebcomponentIdentifier, clickEvent: TemplateClickEvent, data?: any): void {
        const webElement = this.document.querySelector(webcomponentIdentifier);
        const event: CustomEvent = new CustomEvent(this.templateClickEvent, {
            detail: { clickEvent, data }
        });
        webElement?.dispatchEvent(event);
    }

    private setupTemplateClickActions(settings: TemplateSettings): void {
        this.templateClickActions = { webcomponentName: settings.webcomponentIdentifier, eventActions: [] };
        this.templateClickActions.eventActions.push({ event: TemplateClickEvent.PRIMARYACTION, action: settings.primaryActionClicked });
        this.templateClickActions.eventActions.push({ event: TemplateClickEvent.SECONDARYACTION, action: settings.secondaryActionClicked });
        this.templateClickActions.eventActions.push({ event: TemplateClickEvent.CHATNOTIFICATION, action: settings.chatNotificationSent });
        this.templateClickActions.eventActions.push({ event: TemplateClickEvent.CLOSETEMPLATE, action: settings.closeTemplate });
        const webElement = this.document.querySelector(this.templateClickActions.webcomponentName);
        if (webElement && webElement.getAttribute('listener') == null) {
            webElement.setAttribute('listener', 'true');
            webElement.addEventListener('templateClickEvent', (event: CustomEvent) => {
                if (event.detail.hasOwnProperty('data') && event.detail.data !== undefined) {
                    this.templateClickActions.eventActions
                        .find((eventAction) => eventAction.event === event.detail?.clickEvent)
                        ?.action(event.detail.data);
                    return;
                }
                this.templateClickActions.eventActions.find((eventAction) => eventAction.event === event.detail?.clickEvent)?.action();
            });
        }
    }
}
